import React, { Component } from 'react';
import { GetLogProcessosDetails } from '../../../../services';
import { format } from 'date-fns';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CSpinner,
  CForm,
  CFormInput
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilMagnifyingGlass,cilReload  } from '@coreui/icons';
import axios from 'axios';
const today = new Date();
const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;


export default class List extends Component {
  constructor(props) {
    super(props);
    let userdata = this.props.location.state || {};
    this.state = {
      getList: [],
      isLoaded: false,
      showDetails: false,
      selectedLog: [],
      historicalData2: [],      
      filterDate: formattedDate,
      filterProcesso: userdata.processo,
      filterStatus: '',
      filterNome: userdata.nome_filial,
      filterOperadora: userdata.operadora,
      tipo:""
    };
  }

  async componentDidMount() {
    // this.interval = setInterval(() => {
    //   this.getLog();
    // }, 5000); // 2000ms = 2 segundos    
    this.getLog()
  }

  // componentWillUnmount() {
  //   // Limpar o intervalo quando o componente for desmontado
  //   clearInterval(this.interval);
  // }

  async getLog() {
    this.setState({ isLoaded: true });
    let list = await GetLogProcessosDetails.LogProcessosList();
    console.log(list)
    if (list) {
      this.setState({ getList: list.data });
    }
    this.setState({ isLoaded: false });
  }

  handleShowDetails = (item) => {
    this.setState((prevState) => ({
      showDetails: !prevState.showDetails,
      selectedLog: prevState.showDetails ? [] : item.detalhe_logs || [],
      historicalData2: []      
    }));

    this.setState({ tipo:item.nome });
    a
  }

  handleMessageClick = async (mensagem) => {
    try {
      this.setState({ isLoaded: true });    
      // Define a URL com base no valor de state.tipo
      // const url =
      //   this.state.tipo === 'Entrada NFs'
      //     ? 'http://localhost:9003/ConfirmarEntrada?sequencia=' + mensagem
      //     : 'http://localhost:9005/ConfirmarSaida?sequencia=' + mensagem;
  
        const url =
           this.state.tipo === 'Entrada NFs'
             ? 'https://integradorbaoba.masterdaweb.net/api/nf_entrada/ConfirmaEntrada?sequencia=' + mensagem
             : 'https://integradorbaoba.masterdaweb.net/api/nf_saida/ConfirmaSaida?sequencia=' + mensagem;

      
      // Configuração da requisição
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url
      };
  
      try {
        // Faz a requisição
        const response = await axios.request(config);
        this.setState({
          historicalData2: response.data,
          isLoaded: false, // Finaliza o carregamento após sucesso
        });
      } catch (error) {
        console.error('Erro ao obter dados do histórico:', error);
        this.setState({ isLoaded: false });
      }
  
    } catch (error) {
      console.error('Erro ao obter dados do histórico:', error);
      this.setState({ isLoaded: false });
    }
  };
  

  handleInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    const { getList, isLoaded, showDetails, selectedLog, historicalData2, filterDate, filterProcesso, filterStatus, filterNome, filterOperadora } = this.state;

    // Filtrar getList com base nos filtros
    const filteredGetList = getList.filter(item => {
      return (
        (!filterDate || format(new Date(item.createdAt), 'yyyy-MM-dd') === filterDate) &&
        (!filterProcesso || item.nome.toLowerCase().includes(filterProcesso.toLowerCase())) &&
        (!filterStatus || item.status.toLowerCase().includes(filterStatus.toLowerCase())) &&
        (!filterNome || item.filiai.nome.toLowerCase().includes(filterNome.toLowerCase())) &&
        (!filterOperadora || item.operadora.toLowerCase().includes(filterOperadora.toLowerCase()))
      );
    });

    return (
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>Consulta Logs Execução</CCardHeader>            
            <CCardBody>
              <CForm>
                <CRow className="mb-3">
                  <CCol md={2}>
                    <CFormInput
                      type="date"
                      name="filterDate"
                      value={filterDate}
                      onChange={this.handleInputChange}
                    />
                  </CCol>
                  <CCol md={2}>
                    <CFormInput
                      type="text"
                      placeholder="Processo"
                      name="filterProcesso"
                      value={filterProcesso}
                      onChange={this.handleInputChange}
                    />
                  </CCol>
                  <CCol md={2}>
                    <CFormInput
                      type="text"
                      placeholder="Status"
                      name="filterStatus"
                      value={filterStatus}
                      onChange={this.handleInputChange}
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      placeholder="Filial"
                      name="filterNome"
                      value={filterNome}
                      onChange={this.handleInputChange}
                    />
                  </CCol>
                  <CCol md={3}>
                    <CFormInput
                      type="text"
                      placeholder="Operadora"
                      name="filterOperadora"
                      value={filterOperadora}
                      onChange={this.handleInputChange}
                    />
                  </CCol>
                </CRow>
              </CForm>
              {isLoaded && <CSpinner color="success" style={{ flexDirection: 'row', marginLeft: '50%', alignItems: "center" }} />}
              <CTable align="middle" className="mb-0 border card-body-table table" hover responsive small bordered style={{ fontFamily: "Arial" }}>
                <CTableHead color="dark">
                  <CTableRow color="dark">
                    <CTableHeaderCell>Atualizar</CTableHeaderCell>
                    <CTableHeaderCell>Data</CTableHeaderCell>
                    <CTableHeaderCell>Processo</CTableHeaderCell>
                    <CTableHeaderCell>Mensagem</CTableHeaderCell>
                    <CTableHeaderCell>Status</CTableHeaderCell>
                    <CTableHeaderCell>Filial</CTableHeaderCell>
                    <CTableHeaderCell>Operadora</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Detalhes</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {filteredGetList.map((item, index) => (
                    <CTableRow key={index} color="success" style={{ color: "green" }}>
                      <CTableDataCell className="text-center" onClick={() => this.getLog()}>
                        <CIcon icon={cilReload} title='Detalhes' />
                      </CTableDataCell>
                      <CTableDataCell>{format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm:ss')}</CTableDataCell>
                      <CTableDataCell>{item.nome}</CTableDataCell>
                      <CTableDataCell>{item.mensagem}</CTableDataCell>
                      <CTableDataCell>{item.status}</CTableDataCell>
                      <CTableDataCell>{item.filiai.nome}</CTableDataCell>
                      <CTableDataCell>{item.operadora}</CTableDataCell>
                      <CTableDataCell className="text-center" onClick={() => this.handleShowDetails(item)}>
                        <CIcon icon={cilMagnifyingGlass} title='Detalhes' />
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
              
            </CCardBody>
          </CCard>
        </CCol>

        {showDetails && (
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>Detalhes Logs NFs</CCardHeader>
              {isLoaded && <CSpinner color="success" style={{ flexDirection: 'row', marginLeft: '50%', alignItems: "center" }} />}
              <CCardBody>
                <CTable align="middle" className="mb-0 border card-body-table table" hover responsive small bordered style={{ fontFamily: "Arial" }}>
                  <CTableHead color="dark">
                    <CTableRow color="dark">
                      <CTableHeaderCell>Data</CTableHeaderCell>
                      <CTableHeaderCell>Mensagem</CTableHeaderCell>
                      <CTableHeaderCell>Status</CTableHeaderCell>
                      <CTableHeaderCell>NFE</CTableHeaderCell>
                      <CTableHeaderCell>Chave</CTableHeaderCell>                  
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {selectedLog.map((item, index) => (
                      <CTableRow key={index} color="success" style={{ color: "green" }}>
                        <CTableDataCell>{format(new Date(item.createdat), 'dd/MM/yyyy HH:mm:ss')}</CTableDataCell>
                       <CTableDataCell>
                          {item.status === 'Enviado' || item.status === 'Enviado'  ? (
                            <button onClick={() => this.handleMessageClick(item.mensagem)}>
                              {item.mensagem}
                            </button>
                          ) : (
                            item.mensagem
                          )}
                        </CTableDataCell>
                        <CTableDataCell>{item.status}</CTableDataCell>
                        <CTableDataCell>{item.nnf}</CTableDataCell>
                        <CTableDataCell>{item.chavenfe}</CTableDataCell>                     
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </CCardBody>
            </CCard>
          </CCol>
        )}

        {historicalData2.length > 0 && (
          <CCol xs={12} style={{ marginTop: '20px' }}>
            <CCard className="mb-4">            
              <CCardHeader>Retorno API</CCardHeader>
              <CCardBody>
                <CTable align="middle" className="mb-0 border card-body-table table" hover responsive small bordered style={{ fontFamily: "Arial" }}>
                  <CTableHead color="dark">
                    <CTableRow color="dark">
                      <CTableHeaderCell>Sequência Histórico</CTableHeaderCell>
                      <CTableHeaderCell>Data e Hora</CTableHeaderCell>
                      {/* <CTableHeaderCell>Operadora</CTableHeaderCell> */}
                      <CTableHeaderCell>Status</CTableHeaderCell>
                      <CTableHeaderCell>Motivo</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {historicalData2.map((item, index) => (
                      <CTableRow key={index} color="success" style={{ color: "green" }}>
                        <CTableDataCell>{item.sequenciaIntegracao}</CTableDataCell>
                        <CTableDataCell>{format(new Date(item.dataProcessamento), 'dd/MM/yyyy HH:mm:ss')}</CTableDataCell>
                        {/* <CTableDataCell>{item.operadora}</CTableDataCell> */}
                        <CTableDataCell>{item.estadoIntegracao}</CTableDataCell>
                        <CTableDataCell>{item.detalheHistorico}</CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </CCardBody>
            </CCard>
          </CCol>
        )}
      </CRow>
    );
  }
}


